export default __webpack_public_path__ + "img/web-hour-top-9133c49e.png";